/* 🤖 this file was generated by svg-to-ts */
export const matIconDesktopWindows: {
  name: 'desktop-windows';
  data: string;
} = {
  name: 'desktop-windows',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"/></svg>`
};
